class FooterMenu {
    constructor(menu) {
        this.menu = menu;
        this.animationDuration = 240;
        this.menu.classList.add('is-enhanced');
        this.initSubmenus();
    }

    initSubmenus() {
        const itemsWithChildren = this.menu.querySelectorAll('.menu-item-has-children');

        itemsWithChildren.forEach((item, index) => {
            const link = item.querySelector(':scope > a');
            const submenu = item.querySelector(':scope > .sub-menu');

            if (!link || !submenu) {
                return;
            }

            const controlsId = submenu.id || `footer-submenu-${index + 1}`;
            const shouldStartOpen = false;

            submenu.id = controlsId;
            this.setInitialSubmenuState(submenu, shouldStartOpen);

            const toggle = document.createElement('button');
            toggle.type = 'button';
            toggle.className = 'footer__submenu-toggle';
            toggle.setAttribute('aria-expanded', String(shouldStartOpen));
            toggle.setAttribute('aria-controls', controlsId);
            toggle.setAttribute('aria-label', shouldStartOpen ? 'Zwiń podmenu' : 'Rozwiń podmenu');

            toggle.addEventListener('click', () => {
                const isExpanded = toggle.getAttribute('aria-expanded') === 'true';

                this.toggleSubmenu(item, submenu, toggle, !isExpanded);
            });

            link.addEventListener('click', (event) => {
                const isExpanded = toggle.getAttribute('aria-expanded') === 'true';
                const href = (link.getAttribute('href') || '').trim();
                const isPlaceholderLink = href === '' || href === '#';

                if (!isExpanded) {
                    event.preventDefault();
                    this.toggleSubmenu(item, submenu, toggle, true);
                    return;
                }

                if (isPlaceholderLink) {
                    event.preventDefault();
                    this.toggleSubmenu(item, submenu, toggle, false);
                }
            });

            item.classList.toggle('is-open', shouldStartOpen);
            link.insertAdjacentElement('afterend', toggle);
        });
    }

    setInitialSubmenuState(submenu, isOpen) {
        submenu.style.overflow = 'hidden';
        submenu.style.height = isOpen ? 'auto' : '0px';
        submenu.style.opacity = isOpen ? '1' : '0';
        submenu.style.pointerEvents = isOpen ? '' : 'none';
    }

    toggleSubmenu(item, submenu, toggle, shouldOpen) {
        if (submenu.dataset.isAnimating === 'true') {
            return;
        }

        toggle.setAttribute('aria-expanded', String(shouldOpen));
        toggle.setAttribute('aria-label', shouldOpen ? 'Zwiń podmenu' : 'Rozwiń podmenu');
        item.classList.toggle('is-open', shouldOpen);

        if (shouldOpen) {
            this.openSubmenu(submenu);
            return;
        }

        this.closeSubmenu(submenu);
    }

    openSubmenu(submenu) {
        submenu.dataset.isAnimating = 'true';
        submenu.style.pointerEvents = 'none';
        submenu.style.transition = 'none';
        submenu.style.height = '0px';
        submenu.style.opacity = '0';

        requestAnimationFrame(() => {
            const targetHeight = submenu.scrollHeight;

            submenu.style.transition = `height ${this.animationDuration}ms ease, opacity ${this.animationDuration}ms ease`;
            submenu.style.height = `${targetHeight}px`;
            submenu.style.opacity = '1';

            this.finishAnimation(submenu, true);
        });
    }

    closeSubmenu(submenu) {
        submenu.dataset.isAnimating = 'true';
        submenu.style.pointerEvents = 'none';
        submenu.style.transition = 'none';
        submenu.style.height = `${submenu.scrollHeight}px`;
        submenu.style.opacity = '1';

        requestAnimationFrame(() => {
            submenu.style.transition = `height ${this.animationDuration}ms ease, opacity ${this.animationDuration}ms ease`;
            submenu.style.height = '0px';
            submenu.style.opacity = '0';

            this.finishAnimation(submenu, false);
        });
    }

    finishAnimation(submenu, isOpen) {
        window.setTimeout(() => {
            submenu.style.transition = '';
            submenu.style.height = isOpen ? 'auto' : '0px';
            submenu.style.opacity = isOpen ? '1' : '0';
            submenu.style.pointerEvents = isOpen ? '' : 'none';
            submenu.dataset.isAnimating = 'false';
        }, this.animationDuration);
    }
}

document.addEventListener('DOMContentLoaded', () => {
    const menus = document.querySelectorAll('.js-footer-menu');

    menus.forEach((menu) => {
        new FooterMenu(menu);
    });
});